import { Dropdown } from "react-bootstrap";
import {
  formatDriverCurrency,
  formatDriverDate,
  getDriverStatusBadgeClass,
} from "../utils/driver.utils";

const DriversTable = ({ drivers, onEdit, onDelete, isDeleting }) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>User ID</th>
            <th>CNIC</th>
            <th>Contact</th>
            <th>License</th>
            <th>License Expiry</th>
            <th>Driver Type</th>
            <th>Salary</th>
            <th>Status</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {drivers.map((driver, index) => (
            <tr key={driver._id || `${driver.cnic}-${index}`}>
              <td>{index + 1}</td>
              <td>{driver.name || "-"}</td>
              <td>{driver.userId || "-"}</td>
              <td>{driver.cnic || "-"}</td>
              <td>{driver.contactNumber || "-"}</td>
              <td>{driver.license?.number || "-"}</td>
              <td>{formatDriverDate(driver.license?.expiryDate)}</td>
              <td>{driver.employment?.driverType || "-"}</td>
              <td>
                {driver.employment?.salaryType
                  ? `${driver.employment.salaryType} (${formatDriverCurrency(driver.employment.salaryAmount)})`
                  : "-"}
              </td>
              <td>
                <span className={getDriverStatusBadgeClass(driver.status)}>
                  {driver.status || "unknown"}
                </span>
              </td>
              <td>{formatDriverDate(driver.createdAt)}</td>
              <td>
                <Dropdown>
                  <Dropdown.Toggle variant="link" className="p-0 text-decoration-none">
                    &#x2022;&#x2022;&#x2022;
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item onClick={() => onEdit(driver._id)} disabled={!driver._id}>
                      Edit
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => onDelete(driver)}
                      className="text-danger"
                      disabled={!driver._id || isDeleting}
                    >
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DriversTable;
